/**
 * Le Club — staggered scroll reveal.
 *
 * Groups marked [data-lc-reveal] animate their direct children in sequence
 * the first time they enter the viewport. The CSS keeps everything visible
 * until this script marks a group ready, so a failed or blocked script can
 * never leave the page blank.
 */
(function () {
  'use strict';

  var STEP = 70;   // ms between siblings
  var CAP = 8;     // stop staggering past this many, so long lists stay snappy

  function prepare(group) {
    if (group.dataset.lcReady) return;
    var children = group.children;
    for (var i = 0; i < children.length; i++) {
      children[i].style.setProperty('--lc-delay', Math.min(i, CAP) * STEP + 'ms');
    }
    group.dataset.lcReady = 'true';
  }

  function initAll(scope) {
    var groups = (scope || document).querySelectorAll('[data-lc-reveal]');
    if (!groups.length) return;

    if (!('IntersectionObserver' in window)) {
      groups.forEach(function (g) { g.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    groups.forEach(function (group) {
      prepare(group);
      // Already on screen at load: reveal without waiting for a scroll.
      if (group.getBoundingClientRect().top < window.innerHeight) {
        group.classList.add('is-in');
      } else {
        io.observe(group);
      }
    });
  }

  // The flowing "LE CLUB" rings animate with SMIL, which CSS can't stop.
  // Run them only while on screen, so the page isn't repainting type nobody
  // can see, and freeze them when the visitor has asked for less motion.
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var flowIO = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.dataset.lcVisible = entry.isIntersecting ? 'true' : 'false';
          applyFlow(entry.target);
        });
      })
    : null;

  function applyFlow(svg) {
    if (!svg.pauseAnimations) return;
    var hidden = svg.dataset.lcVisible === 'false';
    if ((calm && calm.matches) || hidden) {
      svg.pauseAnimations();
    } else {
      svg.unpauseAnimations();
    }
  }

  function settleFlow(scope) {
    (scope || document).querySelectorAll('svg[data-lc-flow]').forEach(function (svg) {
      applyFlow(svg);
      if (flowIO && !svg.dataset.lcFlowWatched) {
        svg.dataset.lcFlowWatched = 'true';
        flowIO.observe(svg);
      }
    });
  }

  if (calm && calm.addEventListener) {
    calm.addEventListener('change', function () { settleFlow(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); settleFlow(); });
  } else {
    initAll();
    settleFlow();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    settleFlow(event.target);
  });
})();
